$('document').ready(function () {

    var devisSigneDateDay = $('#ash_administration_DEVIS_SIGN_DATE_day');
    var devisSigneDateMonth = $('#ash_administration_DEVIS_SIGN_DATE_month');
    var devisSigneDateYear = $('#ash_administration_DEVIS_SIGN_DATE_year');

    var devisSendingDateDay = $('#ash_administration_DEVIS_SENDING_DATE_day');
    var devisSendingDateMonth = $('#ash_administration_DEVIS_SENDING_DATE_month');
    var devisSendingDateYear = $('#ash_administration_DEVIS_SENDING_DATE_year');

    if (devisSigneDateDay.length > 0 & devisSigneDateMonth.length > 0 & devisSigneDateYear.length > 0
        & devisSendingDateDay.length > 0 & devisSendingDateMonth.length > 0 & devisSendingDateYear.length > 0) {
        devisSendingDateDay.change(function () {
            if (devisSigneDateDay.val() == "") {
                devisSigneDateDay.val($(this).val());
            }
        });
        devisSendingDateMonth.change(function () {
            if (devisSigneDateMonth.val() == "") {
                devisSigneDateMonth.val($(this).val());
            }
        });
        devisSendingDateYear.change(function () {
            if (devisSigneDateYear.val() == "") {
                devisSigneDateYear.val($(this).val());
            }
        });
    }

    var subContractorContainer = $("#identite_du_sous_traitant_wrapper, #identite_du_sous_traitant");
    var invMeoInput = $('input:radio[name*=INV_PRO_MOA]');

    if (isSubcontracting()) {
        displayContainer(subContractorContainer);
        enableInvMeoInputs();
    } else {
        hideContainer(subContractorContainer);
        disableInvMeoInputs();
    }

    invMeoInput.on('change', function () {
        if ($(this).is(':checked') && $(this).val() == 1) {
            displayContainer(subContractorContainer);
            enableInvMeoInputs();
        } else {
            hideContainer(subContractorContainer);
            disableInvMeoInputs();
        }
    });

    function disableInvMeoInputs() {
        subContractorContainer.find('input').prop( "disabled", true );
    }
    function enableInvMeoInputs() {
        subContractorContainer.find('input').prop( "disabled", false );
    }

    var invEnrInputs = $('input:radio[name*=ASH_ENR]');
    var invEnrComb = $('[name="ash_administration[INV_ENR_COMB]"]');

    if (isElecEnr()) {
        hideContainer(invEnrComb.closest('.col-md-12'));
    } else {
        displayContainer(invEnrComb.closest('.col-md-12'));
    }

    invEnrInputs.on('change', function () {

        if ($(this).is(':checked') && $(this).val() == 2) {
            displayContainer(invEnrComb.closest('.col-md-12'));
        } else {
            hideContainer(invEnrComb.closest('.col-md-12'))
        }
    });

    var cdpEnrInputs = $('input:radio[name="ash_administration[INV_CDP_ENR]"]');
    var cdpEnrComb = $('[name="ash_administration[INV_CDP_ENR_COMB]"]');
    var isCondChaudTertiaire = $('[name="ash_administration[INV_IS_COND_CHAUD_TERTIAIRE]"]');

    if (isCdpElecEnr()) {
        hideContainer(cdpEnrComb.closest('.col-md-12'));
        hideContainer(isCondChaudTertiaire.closest('.col-md-12'));
    } else {
        displayContainer(cdpEnrComb.closest('.col-md-12'));
        displayContainer(isCondChaudTertiaire.closest('.col-md-12'));
    }

    cdpEnrInputs.on('change', function () {
        if ($(this).is(':checked') && $(this).val() == 2) {
            displayContainer(cdpEnrComb.closest('.col-md-12'));
            displayContainer(isCondChaudTertiaire.closest('.col-md-12'));
        } else {
            hideContainer(cdpEnrComb.closest('.col-md-12'));
            hideContainer(isCondChaudTertiaire.closest('.col-md-12'))
        }
    });

    // BAR-TH-171 / BAR-TH-172 — n° d'agrément PAC affiché uniquement si la PAC est fabriquée dans l'EEE (INV_PAC_EEE = OUI = 1)
    var pacEeeInputs = $('input:radio[name="ash_administration[INV_PAC_EEE]"]');
    var agrPacAdeme = $('[name="ash_administration[INV_AGR_PAC_ADEME]"]');

    if (pacEeeInputs.filter(':checked').val() == 1) {
        displayContainer(agrPacAdeme.closest('.col-md-12'));
    } else {
        hideContainer(agrPacAdeme.closest('.col-md-12'));
    }

    pacEeeInputs.on('change', function () {
        if ($(this).is(':checked') && $(this).val() == 1) {
            displayContainer(agrPacAdeme.closest('.col-md-12'));
        } else {
            hideContainer(agrPacAdeme.closest('.col-md-12'));
        }
    });

    var cdpPoseInput = $('input:radio[name="ash_administration[INVOICE_MCDP1]"]');
    var isCondChaudInput = $('input:hidden[name="ash_administration[INV_IS_COND_CHAUD]"]');

    cdpPoseInput.on('change', function () {
        if ($(this).is(':checked') && $(this).val() == 2) {
            isCondChaudInput.val(0);
        } else {
            isCondChaudInput.val(1);
        }
    });

    /* Start res-ec-104 */
    //as per PE-911
    // var $typeLight = $('[name="ash_administration[INV_TYPE_LIGHT]"]');
    // if ($typeLight.length > 0 && typeof QUOTATION_DATE !== 'undefined' && new Date(QUOTATION_DATE) >= new Date('2025-01-01') && new Date(QUOTATION_DATE) < new Date('2025-11-26')) {
    //     var $nLightInstalled = $('[name="ash_administration[INVOICE_NLIGHT]"]').closest('.col-lg-6'); // hide if 2
    //     var $nLightInstalledDetec = $('[name="ash_administration[INV_NLIGHT_DETEC]"]').closest('.col-lg-6'); // show if 3
    //     var $nLightReequip = $('[name="ash_administration[INV_LUM_REEQUIP]"]').closest('.col-lg-6'); // show if 3
    //     var $nLightReequipDitec = $('[name="ash_administration[INV_LUM_REEQUIP_DETEC]"]').closest('.col-lg-6'); // show if 3
    //     var $ip = $('[name="ash_administration[INVOICE_IP]"]').closest('.col-lg-6'); // hide if 2
    //
    //     if ($typeLight.val() == 1) {
    //         $nLightInstalled.show();
    //         $nLightInstalledDetec.show();
    //         $nLightReequip.hide();
    //         $nLightReequipDitec.hide();
    //         $ip.show();
    //     } else if ($typeLight.val() == 2) {
    //         $nLightInstalled.hide();
    //         $nLightInstalledDetec.hide();
    //         $nLightReequip.show();
    //         $nLightReequipDitec.show();
    //         $ip.hide();
    //     } else if ($typeLight.val() == 3) {
    //         $nLightInstalled.show();
    //         $nLightInstalledDetec.show();
    //         $nLightReequip.show();
    //         $nLightReequipDitec.show();
    //         $ip.show();
    //     } else {
    //         $nLightInstalled.hide();
    //         $nLightInstalledDetec.hide();
    //         $nLightReequip.hide();
    //         $nLightReequipDitec.hide();
    //         $ip.show();
    //     }
    //
    //     $typeLight.on('change', function () {
    //         if ($(this).val() == 1) {
    //             $nLightInstalled.show();
    //             $nLightInstalledDetec.show();
    //             $nLightReequip.hide();
    //             $nLightReequipDitec.hide();
    //             $ip.show();
    //         } else if ($(this).val() == 2) {
    //             $nLightInstalled.hide();
    //             $nLightInstalledDetec.hide();
    //             $nLightReequip.show();
    //             $nLightReequipDitec.show();
    //             $ip.hide();
    //         } else if ($(this).val() == 3) {
    //             $nLightInstalled.show();
    //             $nLightInstalledDetec.show();
    //             $nLightReequip.show();
    //             $nLightReequipDitec.show();
    //             $ip.show();
    //         } else {
    //             $nLightInstalled.hide();
    //             $nLightInstalledDetec.hide();
    //             $nLightReequip.hide();
    //             $nLightReequipDitec.hide();
    //             $ip.show();
    //         }
    //     });
    // }
    /* End res-ec-104 */

    /* Start BAR-TH-137 */
    var $logement = $('[name="ash_administration[ASH_LOG4]"]');
    if ($logement.length > 0 ) {
        var $adressestation = $('[name="ash_administration[INV_ADRESSE_SOUS_STATION]"]').closest('.col-md-12');
        var $zipcodestation = $('[name="ash_administration[INV_ZIPCODE_SOUS_STATION]"]').closest('.col-lg-6');
        var $villestation = $('[name="ash_administration[INV_CITY_SOUS_STATION]"]').closest('.col-lg-6');
        var $resprincipale = $('[name="ash_administration[ASH_RES_PRINCIPALE]"]').closest('.col-md-12');
        if ($('[name="ash_administration[ASH_LOG4]"]:checked').val() == 2) {
            $adressestation.show();
            $zipcodestation.show();
            $villestation.show();
            $resprincipale.hide();
        } else if ($('[name="ash_administration[ASH_LOG4]"]:checked').val() == 1) {
            $resprincipale.show();
            $adressestation.hide();
            $zipcodestation.hide();
            $villestation.hide();
        } else {
            $adressestation.hide();
            $zipcodestation.hide();
            $villestation.hide();
            $resprincipale.hide();
        }
        $logement.on('change', function () {
            if ($(this).is(':checked')) {
                if ($(this).val() == 2) {
                    $adressestation.show();
                    $zipcodestation.show();
                    $villestation.show();
                    $resprincipale.hide();
                } else if ($(this).val() == 1) {
                    $resprincipale.show();
                    $adressestation.hide();
                    $zipcodestation.hide();
                    $villestation.hide();
                }
            }
        });
    }
    /* End BAR-TH-137 */

    /* Start bar-th-163 */
    var $typeOperation = $('[name="ash_administration[INV_OPER_CONDUIT]"]');

    if ($typeOperation.length > 0 && (new Date(QUOTATION_DATE) >= new Date('2021-11-01'))) {
        var $replaceType = $('[name="ash_administration[INV_REPLACE_TYPE]"]').closest('.col-md-12'); // hide if 2
        var $isConduit = $('[name="ash_administration[INV_IS_CONDUIT_SIMULTANEOUS]"]').closest('.col-md-12'); // show if 3
        var $reuseConduit = $('[name="ash_administration[INV_REUSE_CONDUIT_TYPE]"]').closest('.col-md-12'); // show if 3
        var $longConduit = $('[name="ash_administration[INV_LONG_CONDUIT]"]').closest('.col-md-12'); // show if 3

        if ($typeOperation.length > 2) {
            $typeOperation.parent().find('span.radio-btn').css('width', '100%');
        }
        if ($('[name="ash_administration[INV_OPER_CONDUIT]"]:checked').val() == 2) {
            $replaceType.hide();
            $isConduit.hide();
            $reuseConduit.hide();
            $longConduit.show();
        } else if ($('[name="ash_administration[INV_OPER_CONDUIT]"]:checked').val() == 3) {
            $isConduit.show();
            $reuseConduit.show();
            $replaceType.hide();
            $longConduit.hide();
        } else {
            $replaceType.show();
            $isConduit.hide();
            $reuseConduit.hide();
            $longConduit.hide();
        }

        $typeOperation.on('change', function () {
            if ($(this).is(':checked')) {
                if ($(this).val() == 2) { // Fumée individuel
                    $replaceType.hide();
                    $isConduit.hide();
                    $reuseConduit.hide();
                    $longConduit.show();
                } else if ($(this).val() == 3) { // Fumée collectif
                    $isConduit.show();
                    $reuseConduit.show();
                    $replaceType.hide();
                    $longConduit.hide();
                } else {
                    $replaceType.show();
                    $isConduit.hide();
                    $reuseConduit.hide();
                    $longConduit.hide();
                }
            }
        });
    }
    /* End bar-th-163 */

    /* bar-th-171 172 */
    var $pacAssocSystem = $('[name="ash_administration[INV_PAC_ASSOC_SYSTEM]"]');
    if ($pacAssocSystem.length > 0 ) {
        var $reference = $('[name="ash_administration[INV_PAC_REF]"]').closest('.col-lg-6'); // hide if $pacAssocSystem==2
        var $marque = $('[name="ash_administration[INV_PAC_BRAND]"]').closest('.col-lg-6'); // hide if $pacAssocSystem==2
        if ($('[name="ash_administration[INV_PAC_ASSOC_SYSTEM]"]:checked').val() == 1) {
            $reference.show();
            $marque.show();
        } else {
            $reference.hide();
            $marque.hide();
        }
        $pacAssocSystem.on('change', function () {
            if ($('[name="ash_administration[INV_PAC_ASSOC_SYSTEM]"]:checked').val() == 1) {
                $reference.show();
                $marque.show();
            } else {
                $reference.hide();
                $marque.hide();
            }
        })
    }


    /* Start bar-th-173 */
    var $typeDeChauffage = $('[name="ash_administration[INV_TYPE_CHAUFFAGE]"]');
    if ($typeDeChauffage.length > 0 ) {
        var $regulAvecSans = $('[name="ash_administration[INV_GEN_REGUL_AVEC_SANS]"]').closest('.col-md-12'); // hide if not 2
        var $regulRemplace = $('[name="ash_administration[INV_GEN_REGUL_REMPLACE]"]').closest('.col-md-12'); // hide if not 2
        var $regulClassAvant = $('[name="ash_administration[INV_REGUL_CLASS_AVANT]"]').closest('.col-lg-6'); // hide if not 2
        var $regulClassApres = $('[name="ash_administration[INV_REGUL_CLASS_APRES]"]').closest('.col-lg-6'); // hide if not 2
        var $refGenerateur = $('[name="ash_administration[INV_REF_GENERATEUR]"]').closest('.col-lg-6'); // hide if not 2
        var $marqueGenerateur = $('[name="ash_administration[INV_MARQUE_GENERATEUR]"]').closest('.col-lg-6'); // hide if not 2
        var $pce = $('[name="ash_administration[INV_PCE]"]').closest('.col-lg-6'); // hide if not 2
        var $pdl_prm = $('[name="ash_administration[INV_PDL_PRM]"]').closest('.col-lg-6'); // hide if not 1
        var $nbrEmetteurEquip = $('[name="ash_administration[INV_NBR_EMETTEUR_EQUIP]"]'); // hide if not 3
        var $nbrEmetteurValorise = $('[name="ash_administration[INV_NBR_EMETTEUR_VALORISE]"]').attr('disabled', true)// hide if not 3

        function showHideTypeChauff(val) {
            if (val == 1) {
                $regulAvecSans.hide();
                $regulRemplace.hide();
                $regulClassAvant.hide();
                $regulClassApres.hide();
                $refGenerateur.hide();
                $marqueGenerateur.hide();
                $pce.hide();
                $pdl_prm.show(); //show
            } else if (val == 2 || val == 3 ) {
                $regulAvecSans.show();
                if ($('[name="ash_administration[INV_GEN_REGUL_AVEC_SANS]"]:checked').val() == 2) {
                    $regulRemplace.show();
                } else {
                    $regulRemplace.hide();
                }

                if ($('[name="ash_administration[INV_GEN_REGUL_REMPLACE]"]:checked').val() == 1) {
                    $regulClassAvant.show();
                    $regulClassApres.show();
                } else {
                    $regulClassAvant.hide();
                    $regulClassApres.hide();
                }

                $refGenerateur.show();
                $marqueGenerateur.show();
                $pce.show();
                $pdl_prm.hide(); //hide
            } else {
                $regulAvecSans.hide();
                $regulRemplace.hide();
                $regulClassAvant.hide();
                $regulClassApres.hide();
                $refGenerateur.hide();
                $marqueGenerateur.hide();
                $pce.hide();
                $pdl_prm.hide();
            }
            if (val == 3) {
                $pdl_prm.show();
            }
        }

        showHideTypeChauff(parseInt($typeDeChauffage.val()));
        $typeDeChauffage.on('change', function () {
            showHideTypeChauff(parseInt($(this).val()));
        });
        $('[name="ash_administration[INV_GEN_REGUL_AVEC_SANS]"]').on('change', function (){
            if (parseInt($(this).val()) == 2) {
                $regulRemplace.show();
            } else {
                $regulRemplace.hide();
            }
        })
        $('[name="ash_administration[INV_GEN_REGUL_REMPLACE]"]').on('change', function (){
            if (parseInt($(this).val()) == 1) {
                $regulClassAvant.show();
                $regulClassApres.show();
            } else {
                $regulClassAvant.hide();
                $regulClassApres.hide();
            }
        })

        $nbrEmetteurEquip.on('input', function () {
            let val = parseInt($(this).val());
            // Handle empty or invalid input as 0
            if (isNaN(val)) {
                val = 0;
            }
            // Set inputB to min of val and 9
            $nbrEmetteurValorise.val(Math.min(val, 9));
        });
    }
    /* End bar-th-173 */

    var p3HasPac = $('input:radio[name="ash_administration[P3_HAS_PAC]"]');
    var totNewPacPowerInput = $('input[name="ash_administration[P3_TOT_NEW_PAC_POWER]"]').closest('.col-lg-6');
    
    if (p3HasPac.length > 0 && $('input:radio[name="ash_administration[P3_HAS_PAC]"]:checked').val() == 1) {
        totNewPacPowerInput.show();
    } else {
        totNewPacPowerInput.hide();
    }
    p3HasPac.on('change', function () {
        if ($(this).is(':checked') && $(this).val() == 1) {
            totNewPacPowerInput.show();
        } else {
            totNewPacPowerInput.hide();
        }
    });

    // bar-th-101
    $('input[name="ash_administration[INV_CLASS_BALLON]').on('input',function () {
        let currentVal = jQuery(this).val();
        $(this).val(currentVal.toUpperCase().replace(/^([a-zA-Z]).*/g, '$1'));
    });
    //( bar-th-125
    var $typeInstall = $('[name="ash_administration[INV_TYPE_INSTALL]"]');
    var $efficaciteThermique = $('[name="ash_administration[ASH_EFFICACITE_THERMIQUE]"]').closest('.col-lg-6'); // show if 1
    var $classEnergie = $('[name="ash_administration[ASH_CLASS_ENERGIE]"]').closest('.col-lg-6'); // show if 1
    var $surfaceHbitable = $('[name="ash_administration[ASH_SH]"]').closest('.col-lg-6'); // show if 1
    var $nombreApp = $('[name="ash_administration[ASH_NAPP]"]').closest('.col-lg-6'); //show if 3
    var $rendTemp = $('[name="ash_administration[INV_REND_TEMP]"]').closest('.col-lg-6'); //show if 3
    var $puissance = $('[name="ash_administration[ASH_VMC_PUISSANCE_IND]"]').closest('.col-lg-6'); //show if 1 or 2
    var $rappTemp = $('[name="ash_administration[INV_RAPP_TEMP]"]').closest('.col-lg-6'); //show if 1 or 2
    var $efficacite = $('[name="ash_administration[INV_EFFICACITE]"]').closest('.col-lg-6'); //show if 1 or 2

    if ($typeInstall.length > 0) {
        if ($('[name="ash_administration[INV_TYPE_INSTALL]"]:checked').val() == 3) {
            $nombreApp.show();
            $surfaceHbitable.hide();
            $efficaciteThermique.hide();
            $classEnergie.hide();
            $puissance.hide();
            $rendTemp.show();
            $rappTemp.hide();
            $efficacite.show();
        } else if ($('[name="ash_administration[INV_TYPE_INSTALL]"]:checked').val() == 1 || $('[name="ash_administration[INV_TYPE_INSTALL]"]:checked').val() == 2 ) {
            $surfaceHbitable.show();
            $efficaciteThermique.show();
            $classEnergie.show();
            $nombreApp.hide();
            $puissance.show();
            $rendTemp.hide();
            $rappTemp.show();
            $efficacite.hide();
        } else {
            $surfaceHbitable.hide();
            $efficaciteThermique.hide();
            $classEnergie.hide();
            $nombreApp.hide();
            $puissance.hide();
            $rendTemp.hide();
            $rappTemp.show();
            $efficacite.hide();
        }
    }

    $typeInstall.on('change', function () {
        if ($(this).is(':checked')) {
            if ($(this).val() == 3) {
                $nombreApp.show();
                $surfaceHbitable.hide();
                $efficaciteThermique.hide();
                $classEnergie.hide();
                $puissance.hide();
                $rendTemp.show();
                $rappTemp.hide();
                $efficacite.show();
            } else {
                $surfaceHbitable.show();
                $efficaciteThermique.show();
                $classEnergie.show();
                $nombreApp.hide();
                $puissance.show();
                $rendTemp.hide();
                $rappTemp.show();
                $efficacite.hide();
            }
        }
    });

    // Additional fields for BAR-TH-164
    function toggleTravauxAutreInput($this) {
        if ($this.find('input[type=checkbox]').is(":checked")) {
            $('.travaux-autre').show();
        } else {
            $('.travaux-autre').hide();
        }
    }

    let $travauxAutreInput = $('.ash_choice_wrapper').find('.item.autre')
    let $quelTravauxDF = $('.ash_choice_wrapper').find("input[id$='INV_QUELS_TRAVAUX_7']");//double fenetre
    if (!$quelTravauxDF.is(':checked') && typeof ELIGIBLE_WORK !== 'undefined' && ELIGIBLE_WORK == "BAR-TH-164") {
        $quelTravauxDF.parent().remove();
    }
    if ($travauxAutreInput) {
        toggleTravauxAutreInput($travauxAutreInput);
        $travauxAutreInput.on('change', function () {
            toggleTravauxAutreInput($(this));
        })
    }

    // move and show/hide the fields like ‹‹ AUD_#####_POSTFIX ›› just below the each related work checkbox
    let domainWorkElements = $("[data-postfix-id]");
    domainWorkElements.each(function (e) {
        let fieldRow = $(this);
        let val = $(this).data("postfix-id");
        let wrapperParentRow = $('[data-field-wrapper-parent="'+ val +'"]');
        let wrapperRow = $('[data-field-wrapper="'+ val +'"]');
        if (wrapperParentRow.find("input[id^='ash_administration_INV_QUELS_TRAVAUX']").is(":checked")) {
            fieldRow.show();
        }
        wrapperParentRow.find("input[id^='ash_administration_INV_QUELS_TRAVAUX']").on('change', function() {
            if ($(this).is(":checked")) {
                fieldRow.show();
            } else {
                fieldRow.hide();
            }
        })
        if (wrapperRow.find('[data-postfix-id]').hasClass('col-md-12') || wrapperRow.find('[data-postfix-id]').length >= 2) {
            wrapperRow = $('[data-field-wrapper="'+ val +'_b"]');
        }
        let elm = fieldRow.detach();
        wrapperRow.append(elm);
    })


    // end BAR-TH-164

    // bar-en-102
    if (typeof ELIGIBLE_WORK !== 'undefined' && ELIGIBLE_WORK === "BAR-EN-102") {
        let devisSignDate = $('[name^="ash_administration[DEVIS_SIGN_DATE]"]');
        let devisPrevisitDate = $('[name^="ash_administration[DEVIS_PREVISIT_DATE]"]').closest('.col-lg-6');
        let devisPrevisitDateMention = $('[name^="ash_administration[DEVIS_PREVISIT_DATE_MENTION]"]').closest('.col-md-12');
        let devisPrevisitRecordAttached = $('[name^="ash_administration[DEVIS_PREVISIT_RECORD_ATTACHED]"]').closest('.col-md-12');
        let devisWorkStartDate = $('[name^="ash_administration[DEVIS_WORK_START_DATE]"]').closest('.col-md-12');
        if (devisSignDate.length > 0) {
            previsitDateShowHide();
            devisSignDate.on("input", function () {
                previsitDateShowHide();
            })
        }
        function previsitDateShowHide() {
            // var devisSigneDate = new Date(devisSigneDateYear.val()+'-'+devisSigneDateMonth.val()+'-'+devisSigneDateDay.val()+' 00:00:00');
            let year = parseInt(devisSigneDateYear.val());
            let month = parseInt(devisSigneDateMonth.val());
            let day = parseInt(devisSigneDateDay.val());

            if (year > 2022 || (year == 2022 && month >= 5)) {
                devisPrevisitDate.show();
                devisPrevisitDateMention.show();
                devisPrevisitRecordAttached.show();
                devisWorkStartDate.show();
            } else {
                $('[name="ash_administration[DEVIS_PREVISIT_DATE][day]"]').val('')
                $('[name="ash_administration[DEVIS_PREVISIT_DATE][month]"]').val('')
                $('[name="ash_administration[DEVIS_PREVISIT_DATE][year]"]').val('')
                devisPrevisitDate.hide();
                devisPrevisitDateMention.hide();
                devisPrevisitRecordAttached.hide();
                devisWorkStartDate.hide();
            }
        }
    }
    //end bar-en-102

    //tra-eq-117
    if (typeof ELIGIBLE_WORK !== 'undefined' && (ELIGIBLE_WORK === "TRA-EQ-117" || ELIGIBLE_WORK === "TRA-EQ-114")) {
        const $opType     = $('[name^="ash_administration[INV_OP_TYPE]"],[name^="ash_administration[INV_OP_TYPE_114]"]');
        const $demo       = $('[name^="ash_administration[INV_DEMO]"]');

        const $invLoc24m  = $('[name^="ash_administration[INV_LOC_24M]"]').closest('.col-md-12');
        const $invAchat24m= $('[name^="ash_administration[INV_ACHAT_24M]"]').closest('.col-md-12');
        const $invDemoBox = $demo.closest('.col-md-12');
        const $invConcess = $('[name^="ash_administration[INV_DEMO_CONCESS]"]').closest('.col-md-12');
        const $invDelais  = $('[name^="ash_administration[INV_DEMO_DELAIS]"]').closest('.col-md-12');

        function updateOpType() {
            const val = +$opType.val();
            // hide everything first
            $invLoc24m.add($invAchat24m).add($invDemoBox).add($invConcess).add($invDelais).hide();

            if ([1, 2].includes(val)) { //+ converts a string to a number.
                $invAchat24m.show();
                $invDemoBox.show();
                updateDemo(); // ensure demo sub-fields are correct
            }
            else if ([3, 4].includes(val)) {
                $invLoc24m.show();
                $invDemoBox.show();
                updateDemo(); // ensure demo sub-fields are correct
            }
            else {
                $invDemoBox.hide();
            }

            // TRA-EQ-117: INV_VU_MASSE/VU_EEE vs VEHICLE_LEGER_M1_MINIMAL/EU_BATTERIE visibility
            // is handled server-side in AshAdministrationType (based on saved CAT_VEHICLE_1).
            // No JS toggle needed here.
        }

        function updateDemo() {
            const demoVal = $demo.filter(':checked').val();
            $invConcess.add($invDelais).toggle(demoVal == 1);
        }

        updateOpType();
        updateDemo();

        $opType.on('change', updateOpType);
        $demo.on('change', updateDemo);

        // INV_GR_PRO_TYPE ("Type d'activité professionnelle") visible uniquement si INV_GROS_ROULER = OUI (1)
        // cf. AshFieldDisplayConditionsTrait::hide_if_not_gros_rouleur() (contrôle serveur équivalent)
        const $grosRouleur = $('[name^="ash_administration[INV_GROS_ROULER]"]');
        const $grosRouleurContainer = $grosRouleur.closest('.col-md-12');
        const $grProType = $('[name^="ash_administration[INV_GR_PRO_TYPE]"]');
        const $grProTypeContainer = $grProType.closest('.col-md-12');
        const $grProTypeSalarieAlert = $('#gr-pro-type-salarie-alert');
        const $grProTypeIndependantAlert = $('#gr-pro-type-independant-alert');
        // INV_VE_TAXI ("Le véhicule sera-t-il utilisé comme taxi ?") : si OUI, INV_GROS_ROULER (et donc
        // INV_GR_PRO_TYPE) ne s'applique pas - cf. AshAdministrationType (contrôle serveur équivalent,
        // basé sur la valeur sauvegardée au chargement de la page ; ce toggle JS réagit en direct au
        // changement de INV_VE_TAXI avant sauvegarde).
        const $veTaxi = $('[name^="ash_administration[INV_VE_TAXI]"]');
        // Rappel "case Z" affiché uniquement si INV_VE_TAXI = OUI.
        const $veTaxiAlert = $('#ve-taxi-alert');
        // Seuil de prix de INV_VEHICLE_LEGER_M1_MINIMAL : 47 000 € -> 65 000 € si INV_VE_TAXI = OUI
        // (même bascule que sur les simulateurs - cf. toggleVehicleTaxiPriceLabel() dans global_simulator.js).
        const $m1Label = $('[name="ash_administration[INV_VEHICLE_LEGER_M1_MINIMAL]"]')
            .closest('.field-container').find('.ash_input_label label');

        function updateVeTaxiAlert() {
            $veTaxiAlert.toggle($veTaxi.filter(':checked').val() == 1);
        }

        function updateM1PriceLabel() {
            if ($m1Label.length === 0) {
                return;
            }
            const isTaxi = $veTaxi.filter(':checked').val() == 1;
            const text = $m1Label.text();
            if (isTaxi && text.indexOf('47 000') !== -1) {
                $m1Label.text(text.replace('47 000', '65 000'));
            } else if (!isTaxi && text.indexOf('65 000') !== -1) {
                $m1Label.text(text.replace('65 000', '47 000'));
            }
        }

        function updateGrosRouleurVisibility() {
            const isTaxi = $veTaxi.filter(':checked').val() == 1;
            $grosRouleurContainer.toggle(!isTaxi);
            if (isTaxi) {
                $grosRouleur.prop('checked', false);
            }
            updateGrProType();
        }

        function updateGrProType() {
            $grProTypeContainer.toggle($grosRouleur.filter(':checked').val() == 1);
            updateGrProTypeAlert();
        }

        function updateGrProTypeAlert() {
            const isGrosRouleur = $grosRouleur.filter(':checked').val() == 1;
            const val = $grProType.filter(':checked').val();
            $grProTypeSalarieAlert.toggle(isGrosRouleur && val == 1);
            $grProTypeIndependantAlert.toggle(isGrosRouleur && val == 2);
        }

        if ($grosRouleur.length > 0) {
            updateGrosRouleurVisibility();
            $grosRouleur.on('change', updateGrProType);
        }
        if ($grProType.length > 0) {
            $grProType.on('change', updateGrProTypeAlert);
        }
        if ($veTaxi.length > 0) {
            updateVeTaxiAlert();
            updateM1PriceLabel();
            $veTaxi.on('change', function () {
                updateVeTaxiAlert();
                updateGrosRouleurVisibility();
                updateM1PriceLabel();
            });
        }

        // Alert box:
        // Alert box: show when OUI is selected on either of the two EEE/M1 fields.
        // Only one is in the DOM at a time (controlled server-side by AshAdministrationType).
        function updateCumulPrimes() {
            const m1Val    = $('[name="ash_administration[INV_VEHICLE_LEGER_M1_MINIMAL]"]').filter(':checked').val();
            const vuEeeVal = $('[name="ash_administration[INV_VU_EEE]"]').filter(':checked').val();
            $('#cumul-primes-alert').toggle(m1Val == 1 || vuEeeVal == 1);
        }
        updateCumulPrimes();
        $(document).on('change', '[name="ash_administration[INV_VEHICLE_LEGER_M1_MINIMAL]"], [name="ash_administration[INV_VU_EEE]"]', updateCumulPrimes);

        // TRA-EQ-114 : chaînage INV_VE_TAXI=OUI -> INV_VEHICLE_LEGER_M1_MINIMAL, puis
        // INV_VEHICLE_LEGER_M1_MINIMAL=OUI -> INV_EU_BATTERIE (même logique que côté simulation,
        // cf. global_simulator.js::toggleVehicleM1BatteryFields114). Propre à 114 : sur TRA-EQ-117,
        // ces deux champs restent affichés dès "léger" indépendamment de INV_VE_TAXI (comportement
        // existant, inchangé).
        if (ELIGIBLE_WORK === "TRA-EQ-114") {
            const $m1Container = $('[name="ash_administration[INV_VEHICLE_LEGER_M1_MINIMAL]"]').closest('.field-container');
            const $batteryContainer = $('[name="ash_administration[INV_EU_BATTERIE]"]').closest('.field-container');
            const $m1Radios = $('[name="ash_administration[INV_VEHICLE_LEGER_M1_MINIMAL]"]');

            function updateM1BatteryVisibility114() {
                const isTaxi = $veTaxi.filter(':checked').val() == 1;
                $m1Container.toggle(isTaxi);
                if (!isTaxi) {
                    $m1Radios.filter('[value="2"]').prop('checked', true);
                }

                const isM1Ok = isTaxi && $m1Radios.filter(':checked').val() == 1;
                $batteryContainer.toggle(isM1Ok);
                if (!isM1Ok) {
                    $batteryContainer.find('input[value="2"]').prop('checked', true);
                }
            }

            if ($m1Container.length > 0) {
                updateM1BatteryVisibility114();
                $veTaxi.on('change', updateM1BatteryVisibility114);
                $m1Radios.on('change', updateM1BatteryVisibility114);
            }
        }
    }

    //tra-eq-133 (véhicule d'occasion)
    if (typeof ELIGIBLE_WORK !== 'undefined' && ELIGIBLE_WORK === "TRA-EQ-133") {
        const $opTypeOcc  = $('[name^="ash_administration[INV_OP_TYPE_OCC]"]');
        const $achat36m   = $('[name^="ash_administration[INV_ACHAT_36M]"]').closest('.col-md-12');
        const $loc36m     = $('[name^="ash_administration[INV_LOC_36M]"]').closest('.col-md-12');

        const $serviceAuto = $('[name^="ash_administration[INV_SERVICE_AUTONOMIE]"]');
        const $m1Occasion  = $('[name^="ash_administration[INV_M1_OCCASION]"]').closest('.col-md-12');

        const $typeBenef    = $('[name^="ash_administration[INV_TYPE_BENEFICIAIRE]"]');
        const $typeBenefBox = $typeBenef.closest('.col-md-12');

        function updateOpTypeOcc() {
            const val = +$opTypeOcc.val();
            $achat36m.add($loc36m).hide();
            if (val === 1) {        // achat d'occasion
                $achat36m.show();
            } else if (val === 2) { // location d'occasion
                $loc36m.show();
            }
        }

        function updateTypeBeneficiaire() {
            const serviceOui = $serviceAuto.filter(':checked').val() == 1;
            const val = serviceOui ? $typeBenef.val() : '';
            $('#infobulle-benef-1, #infobulle-benef-2, #infobulle-benef-3').addClass('hidden');
            if (val == 1 || val == 2 || val == 3) {
                $('#infobulle-benef-' + val).removeClass('hidden');
            }
        }

        function updateServiceAuto() {
            const val = $serviceAuto.filter(':checked').val();
            $m1Occasion.toggle(val == 1);   // affiché seulement si OUI
            $typeBenefBox.toggle(val == 1); // « Le bénéficiaire est : » affiché seulement si OUI
            updateTypeBeneficiaire();
        }

        updateOpTypeOcc();
        updateServiceAuto();

        $opTypeOcc.on('change', updateOpTypeOcc);
        $serviceAuto.on('change', updateServiceAuto);
        $typeBenef.on('change', updateTypeBeneficiaire);
    }

    // bar-th-178, 179, 180
    var isBarTh178 = typeof ELIGIBLE_WORK !== 'undefined' && ELIGIBLE_WORK === "BAR-TH-178";
    var isBarTh179 = typeof ELIGIBLE_WORK !== 'undefined' && ELIGIBLE_WORK === "BAR-TH-179";
    var isBarTh180 = typeof ELIGIBLE_WORK !== 'undefined' && ELIGIBLE_WORK === "BAR-TH-180";
    var isBatTh162 = typeof ELIGIBLE_WORK !== 'undefined' && ELIGIBLE_WORK === "BAT-TH-162";
    var isBatTh163 = typeof ELIGIBLE_WORK !== 'undefined' && ELIGIBLE_WORK === "BAT-TH-163";
    var isBatTh164 = typeof ELIGIBLE_WORK !== 'undefined' && ELIGIBLE_WORK === "BAT-TH-164";
    if (isBarTh178 || isBarTh179 || isBarTh180 || isBatTh162 || isBatTh163 || isBatTh164) {
        const $pacPower     = $('[name^="ash_administration[INV_NOM_PAC_POWER]"]');
        const $newTotPower  = $('[name^="ash_administration[INV_TOT_NEW_PAC_POWER]"]').closest('.col-lg-6');

        const toggleNewTotPower = () => {
            let flag = $('[name^="ash_administration[INV_MORE_PAC]"]:checked').val() == 1
            $newTotPower.toggle(flag);
            if (!flag) {
                $('[name^="ash_administration[INV_TOT_NEW_PAC_POWER]"]').val(0);
            }
        };
        if (isBatTh163 || isBatTh164) {
            const $etas         = $('[name^="ash_administration[INV_ETAS]"]').closest('.col-lg-6');
            const $cop          = $('[name^="ash_administration[INV_COP]"]').closest('.col-lg-6');
            const toggleEtasCop = () => {
                const $pacPowerVal = $('[name^="ash_administration[INV_POWER_THERMPAC]"]:checked').val();
                $etas.toggle($pacPowerVal == 1); //<=400
                $cop.toggle($pacPowerVal == 2);
            };
            toggleEtasCop();
            $('[name^="ash_administration[INV_POWER_THERMPAC]"]').on('click', toggleEtasCop);
        }
        //for all barth178/179/180
        toggleNewTotPower();
        $('[name^="ash_administration[INV_MORE_PAC]"]').on('change', toggleNewTotPower);

        if (isBarTh178 || isBatTh162) { //only barth178
            const $usageInputs  = $('input[name="ash_administration[INV_USAGE][]"]');
            const $modeFroid    = $('[name^="ash_administration[INV_MODE_FROID]"]');
            const $modeFroidCol = $modeFroid.closest('.col-lg-6');
            const $etas         = $('[name^="ash_administration[INV_ETAS]"]').closest('.col-lg-6');
            const $cop          = $('[name^="ash_administration[INV_COP]"]').closest('.col-lg-6');
            const $eer          = $('[name^="ash_administration[INV_EER]"]').closest('.col-lg-6');
            const $seer         = $('[name^="ash_administration[INV_SEER]"]').closest('.col-lg-6');

            const toggleEtasCop = () => {
                const power = Number($pacPower.val());
                $etas.toggle(power <= 400);
                $cop.toggle(power > 400);
            };
            const toggleEerSeer = () => {
                const mode = $modeFroid.val();
                $eer.toggle(mode == 1);
                $seer.toggle(mode == 2);
            };
            const getUsageValues = () =>
                $usageInputs.filter(':checked').map((_, el) => el.value).get();
            const toggleFroid = () => {
                const hasCooling = getUsageValues().includes('3');
                $modeFroidCol.toggle(hasCooling);
                if (!hasCooling) {
                    $eer.hide();
                    $seer.hide();
                    return;
                }
                toggleEerSeer();
            };

            toggleEtasCop();
            toggleFroid();
            $pacPower.on('change', toggleEtasCop);
            $usageInputs.on('change', toggleFroid);
            $modeFroid.on('change', toggleEerSeer);
        }//barth178

    } //end bar-th-178/179/180

    if (isCondChaud()) {
        $('input:radio[name="ash_administration[INVOICE_MCDP1]"][value="1"]').prop('checked', true);
    }

    /**
     *
     * @param elementToShow
     */
    function displayContainer(elementToShow) {
        elementToShow.show();
    }

    /**
     *
     * @param elementToHide
     */
    function hideContainer(elementToHide) {
        elementToHide.hide();
    }

    /**
     *
     * @returns {boolean}
     */
    function isSubcontracting() {
        return (invMeoInput.is(':checked') && invMeoInput.prop('checked') == 1);
    }

    /**
     *
     * @returns {*|jQuery|boolean}
     */
    function isElecEnr() {
        return (invEnrInputs.is(':checked') && invEnrInputs.prop('checked') == 1);
    }

    /**
     *
     * @returns {*|jQuery|boolean}
     */
    function isCdpElecEnr() {
        return (cdpEnrInputs.is(':checked') && cdpEnrInputs.prop('checked') == 1);
    }

    function isCondChaud() {
        return (isCondChaudInput.val() == 1);
    }

    var cdpEnrAuditInputs = $('input:radio[name="ash_administration[INV_CDP_ENR_AUDIT]"]');
    var cdpEnrCompAuditInput = $('select[name*="ash_administration[INV_CDP_ENR_COMB_AUDIT]"]');

    if ($('input:radio[name="ash_administration[INV_CDP_ENR_AUDIT]"]:checked').val() == 1) {
        cdpEnrCompAuditInput.find('option:selected').removeAttr('selected');
        hideContainer(cdpEnrCompAuditInput.closest('.col-md-12'))
    }

    cdpEnrAuditInputs.on('change', function (event) {
        if (event.target.defaultValue == 2) {
            displayContainer(cdpEnrCompAuditInput.closest('.col-md-12'));
        } else {
            cdpEnrCompAuditInput.find('option:selected').removeAttr('selected');
            hideContainer(cdpEnrCompAuditInput.closest('.col-md-12'))
        }
    });

    // bar-th-174 175
    var audRenewAirInsuffisant = $('input:radio[name="ash_administration[AUD_RENEW_AIR_INSUFFISANT]"]');
    var audTravauxPreconise = $('input:radio[name="ash_administration[AUD_TRAVAUX_PRECONISES_STEP_1]"]');
    if ($('input:radio[name="ash_administration[AUD_RENEW_AIR_INSUFFISANT]"]:checked').val() != 1) {
        hideContainer(audTravauxPreconise.closest('.col-md-12'))
    }
    audRenewAirInsuffisant.on('change', function (event) {
        if (event.target.defaultValue == 1) {
            displayContainer(audTravauxPreconise.closest('.col-md-12'));
        } else {
            hideContainer(audTravauxPreconise.closest('.col-md-12'))
        }
    });
    //END 174 175

    // reno-globale
    var vmcModelInput = $('input:radio[name="ash_administration[AUD_VMC_MODEL_VMC]"]');
    var vmcTypeInput = $('input:radio[name*="ash_administration[AUD_VMC_TYPE_VMC]"]');
    if ($('input:radio[name="ash_administration[AUD_VMC_MODEL_VMC]"]:checked').val() == 2) {
        vmcTypeInput.find('checked').removeAttr('checked');
        hideContainer(vmcTypeInput.closest('.col-md-12'))
    }
    vmcModelInput.on('change', function (event) {
        if (event.target.defaultValue == 1) {
            displayContainer(vmcTypeInput.closest('.col-md-12'));
        } else {
            vmcTypeInput.find(':checked').removeAttr('checked');
            hideContainer(vmcTypeInput.closest('.col-md-12'))
        }
    });
    //end of reno-globale

    /** <--- beneficiaire coordonnées part **/
    // Modal trigger is only rendered on the extranet subdomain (Twig guards it).
    // Skip this block on pro to avoid hiding the submit button with nothing to replace it.
    if ($('#coordonnesBenficiaireUpdateReasonModalTrigger').length > 0) {
        $('#coordonnesBenficiaireUpdateReasonModalTrigger').hide(); // by default we hide the button which open modal
        let currentBeneficiaireCoordonnesValues = []; // array will contain current beneficiaire values
        let newBeneficiaireCoordonnesValues = []; // array will contain new beneficiaire values
        let beneficiaireCoordonnesInputs = [
            $('#ash_administration_ASH_USER_FIRST_NAME'),
            $('#ash_administration_ASH_USER_LAST_NAME'),
            $('#ash_administration_ASH_USER_EMAIL'),
            $('#ash_administration_ASH_USER_SOCIAL_NAME'),
            $('#ash_administration_ASH_USER_SIREN')
        ]; // array containing inputs elements we want to check if values has been updated

        for (let elem in beneficiaireCoordonnesInputs) { // loop over inputs
            currentBeneficiaireCoordonnesValues.push(beneficiaireCoordonnesInputs[elem].val()); // store current values in array
            newBeneficiaireCoordonnesValues.push(beneficiaireCoordonnesInputs[elem].val()); // store current values in array (easy for comparison)

            beneficiaireCoordonnesInputs[elem].donetyping(function(){ // if user stop writing
                newBeneficiaireCoordonnesValues[elem] = beneficiaireCoordonnesInputs[elem].val(); // store new values in newBeneficiaireCoordonnesValues array
                if(JSON.stringify(newBeneficiaireCoordonnesValues) !== JSON.stringify(currentBeneficiaireCoordonnesValues)) { // compare old vs new values
                    $('#ash_administration_save').hide(); // hide submit button
                    $('#coordonnesBenficiaireUpdateReasonModalTrigger').show(); // show modal button
                } else {
                    $('#ash_administration_save').show(); // show submit button
                    $('#coordonnesBenficiaireUpdateReasonModalTrigger').hide(); // hide modal button
                }
            }, 5)
        }

        $("#coordonnesBenficiaireUpdateReasonModalTrigger").click(function(event) {
            // open modal if we click on modal trigger button
            event.preventDefault();
            $('#coordonnesBenficiaireUpdateReasonModal').modal('show');
        });

        // when modal is open
        $('#coordonnesBenficiaireUpdateReasonModal').on('shown.bs.modal', function () {
            $('#ash_administration_save_2').prop('disabled', true); // disable the submit button

            // enable submit button only if at least one checbkox has been checked
            $('#coordonnesBenficiaireUpdateReasonModal input[name="ash_administration[confirmUpdateDossierCoordonnees][motif][]"]').change(function(event){
                if ($('#coordonnesBenficiaireUpdateReasonModal input[name="ash_administration[confirmUpdateDossierCoordonnees][motif][]"]:checked').length > 0) {
                    // activate validate button
                    $('#ash_administration_save_2').prop('disabled', false);
                } else {
                    // deactivate validate button
                    $('#ash_administration_save_2').prop('disabled', true);
                }
            });
        })
    }
    /** beneficiaire coordonnées part ---> **/

    /* BAR-TH-137 */
    if ($("#ash_administration_HEAT_NETWORK_CONNECTION_1").length) {
        if ($("#ash_administration_HEAT_NETWORK_CONNECTION_1:checked").length) {
            $("#ash_administration_IS_CONNECTION_CERTIFIED_1").closest("div.col-lg-12").show();
        } else {
            $("#ash_administration_IS_CONNECTION_CERTIFIED_1").closest("div.col-lg-12").hide();
        }
        $("input[name='ash_administration[HEAT_NETWORK_CONNECTION]']").on('click', function() {
            if ($(this).val() == 1) {
                $("#ash_administration_IS_CONNECTION_CERTIFIED_1").closest("div.col-lg-12").show();
            } else {
                $("#ash_administration_IS_CONNECTION_CERTIFIED_1").closest("div.col-lg-12").hide();
            }
        });
    }

    /* BAT-TH-127 */
    if ($("input[name='ash_administration[HEAT_NETWORK_CONNECTION]']").length) {
        if ($("input[name='ash_administration[HEAT_NETWORK_CONNECTION]'] option:selected").val() != 1) {
            $("#ash_administration_INV_IS_COND_CHAUD_TERTIAIRE_1").closest("div.col-lg-12").hide();
        }
        $("input[name='ash_administration[HEAT_NETWORK_CONNECTION]']").on("click", function () {
            if ($(this).val() == 1) {
                $("#ash_administration_INV_IS_COND_CHAUD_TERTIAIRE_1").closest("div.col-lg-12").show();
            } else {
                $("#ash_administration_INV_IS_COND_CHAUD_TERTIAIRE_1").closest("div.col-lg-12").hide();
            }
        });
    }

    /* BAT-TH-116 */
    if ($("input[name='ash_administration[OPERATION_TYPE]']").length) {
        if ($("#ash_administration_OPERATION_TYPE_1:checked").length) {
            $("#ash_administration_OLD_STUFF_CLASS_C_1").closest("div.col-md-12").show();
        } else {
            $("#ash_administration_OLD_STUFF_CLASS_C_1").closest("div.col-md-12").hide();
        }
        $("input[name='ash_administration[OPERATION_TYPE]']").on('click', function() {
            if ($(this).val() == 1) {
                $("#ash_administration_OLD_STUFF_CLASS_C_1").closest("div.col-md-12").show();
            } else {
                $("#ash_administration_OLD_STUFF_CLASS_C_1").closest("div.col-md-12").hide();
            }
        });
    }

    /* BAR-TH-173 */
    if ($('select[name="ash_administration[INV_SYSTEM_REGUL]"]').length) {
        var invSystemRegul = $('select[name="ash_administration[INV_SYSTEM_REGUL]"]');
        var invOldSystem = $('select[name="ash_administration[INV_OLD_SYSTEM]"]');
        invSystemRegul.on('change', function (event) {
            if ($(this).val() == 2) {
                invOldSystem.closest('.col-md-12').show();
            }
            else {
                invOldSystem.closest('.col-md-12').hide();
            }
        }).change();
    }

    /* Start BAR-TH-168 */
    // Sélecteurs par suffixe de name (indépendants du nom du form) + wrapper tr/col-md-12 pour marcher
    // AUSSI sur la facture extranet particulier (form_layout = <table>), pas seulement le form pro.
    var WRAP_168 = 'tr, .col-md-12';
    var $usage168 = $('[name$="[INV_USAGE_168]"]');
    if ($usage168.length > 0) {
        var $effAppoint168 = $('[name$="[INV_EFF_APPOINT_168]"]').closest(WRAP_168);
        var $effSais168 = $('[name$="[INV_ETAS]"]').closest(WRAP_168);
        var $profil168 = $('[name$="[INV_PROF_SOUTIRAGE]"]').closest(WRAP_168);
        var $nbBallons168 = $('[name$="[INV_NB_BALLONS_168]"]');
        // Ballon 1 réutilise INV_CAP_STOCK / INV_CLASS_BALLON (BAR-TH-101) ; ballons 2 à 6 = inputs neufs.
        var BALLON_CAP_168 = ['INV_CAP_STOCK', 'INV_CAP_STOCK_2', 'INV_CAP_STOCK_3', 'INV_CAP_STOCK_4', 'INV_CAP_STOCK_5', 'INV_CAP_STOCK_6'];
        var BALLON_CLASSE_168 = ['INV_CLASS_BALLON', 'INV_CLASS_BALLON_2', 'INV_CLASS_BALLON_3', 'INV_CLASS_BALLON_4', 'INV_CLASS_BALLON_5', 'INV_CLASS_BALLON_6'];

        // Efficacités (chauffage + ECS) vs profil de soutirage (ECS seule), selon l'usage.
        function refreshUsage168() {
            var usage = $usage168.is('select') ? $usage168.val() : $usage168.filter(':checked').val();
            if (usage == 1) {
                $effAppoint168.show();
                $effSais168.show();
                $profil168.hide();
            } else if (usage == 2) {
                $effAppoint168.hide();
                $effSais168.hide();
                $profil168.show();
            } else {
                $effAppoint168.hide();
                $effSais168.hide();
                $profil168.hide();
            }
        }

        // Cartouches ballons : ballon i affiché si nombre de ballons >= i ;
        // classe énergétique du ballon i affichée seulement si sa capacité est renseignée et <= 500 L.
        function refreshBallons168() {
            var nb = parseInt($nbBallons168.val(), 10);
            if (isNaN(nb)) {
                nb = 0;
            }
            for (var i = 0; i < BALLON_CAP_168.length; i++) {
                var $cap = $('[name$="[' + BALLON_CAP_168[i] + ']"]');
                var $capContainer = $cap.closest(WRAP_168);
                var $classeContainer = $('[name$="[' + BALLON_CLASSE_168[i] + ']"]').closest(WRAP_168);
                if ((i + 1) <= nb) {
                    $capContainer.show();
                    var cap = parseFloat($cap.val());
                    if (!isNaN(cap) && cap <= 500) {
                        $classeContainer.show();
                    } else {
                        $classeContainer.hide();
                    }
                } else {
                    $capContainer.hide();
                    $classeContainer.hide();
                }
            }
        }

        refreshUsage168();
        refreshBallons168();
        $usage168.on('change', refreshUsage168);
        $nbBallons168.on('change keyup input', refreshBallons168);
        for (var b = 0; b < BALLON_CAP_168.length; b++) {
            $('[name$="[' + BALLON_CAP_168[b] + ']"]').on('change keyup input', refreshBallons168);
        }
    }
    /* End BAR-TH-168 */
});
